class ProductStickyAtc extends HTMLElement {
  constructor() {
    super();

    this.quantityLabel = this.querySelector(
      ".QuantitySelector__CurrentQuantity"
    );
    const decreaseButton = this.querySelector(
      ".QuantitySelector__Button[data-action='decrease-quantity']"
    );
    const increaseButton = this.querySelector(
      ".QuantitySelector__Button[data-action='increase-quantity']"
    );

    decreaseButton.addEventListener("click", this.decreaseQuantity.bind(this));
    increaseButton.addEventListener("click", this.increaseQuantity.bind(this));

    this.querySelector(".ProductForm__AddToCart").addEventListener(
      "click",
      this.addToCart.bind(this)
    );

    this.productFormQuantityLabel = document.querySelector(
      ".Product__Info .QuantitySelector__CurrentQuantity"
    );
    this.productFormQuantityLabel.addEventListener(
      "input",
      this.onChangeProductFormQuantityLabel.bind(this)
    );

    const productFormDecreaseButton = document.querySelector(
      ".Product__Info .QuantitySelector__Button[data-action='decrease-quantity']"
    );
    const productFormIncreaseButton = document.querySelector(
      ".Product__Info .QuantitySelector__Button[data-action='increase-quantity']"
    );
    productFormDecreaseButton.addEventListener(
      "click",
      this.decreaseQuantity.bind(this)
    );
    productFormIncreaseButton.addEventListener(
      "click",
      this.increaseQuantity.bind(this)
    );

    $(window).scroll(() => {
      const productFormAtcOffset = $(".Product__Info .ProductForm__AddToCart").offset().top;
      const headerHeight = $('.Header__Wrapper').height();
      if (productFormAtcOffset - $(window).scrollTop() - headerHeight < 0) {
        $(".product-sticky-atc").addClass("product-sticky-atc--show");
        $(".product-sticky-atc").css("top", Math.floor($('.Header__Wrapper').outerHeight()));
      } else {
        $(".product-sticky-atc").removeClass("product-sticky-atc--show");
      }
    })
  }

  addToCart() {
    const variantId = parseInt(this.querySelector(".variant-id").value);
    const quantity = parseInt(this.quantityLabel.value);
    let formData = {
      items: [
        {
          id: variantId,
          quantity: quantity,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(() => {
        this.setAttribute("aria-hidden", "true");
        this.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: variantId,
              quantity: quantity,
            },
          })
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  decreaseQuantity() {
    const value = Math.max(parseInt(this.quantityLabel.value) - 1, 1);
    this.quantityLabel.value = value;
    this.productFormQuantityLabel.value = value;
    setTimeout(() => {
      this.productFormQuantityLabel.value = value;
    }, 100);
  }

  increaseQuantity() {
    const value = parseInt(this.quantityLabel.value) + 1;
    this.quantityLabel.value = value;
    setTimeout(() => {
      this.productFormQuantityLabel.value = value;
    }, 100);
  }

  onChangeProductFormQuantityLabel() {
    this.quantityLabel.value = this.productFormQuantityLabel.value;
  }
}

customElements.define("product-sticky-atc", ProductStickyAtc);
